import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Table, Data } from 'components/layout/Table'
import { Button, ButtonGroup, BadgesLevels } from 'components/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { tasks as tasksLayout } from 'constants/layout'
import config from 'config'
import { FormattedMessage } from 'react-intl'
import { PROGRESS_STATES } from '../../../../constants/enums'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'
import styles from '../TasksActivitiesTable/tasks-activities-table.styl'


export default class TasksAjEventsTable extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    setParams: PropTypes.func,
    approveModal: PropTypes.func.isRequired,
    rejectModal: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    hideLimit: PropTypes.bool,
    codeLists: PropTypes.object
  }

  static defaultProps = {
    tasks: {
      list: [],
      events: {
        list: []
      }
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      ajEventIdApprove: null,
      ajEventIdReject: null,
      isAssessorManagementEnabled: null
    }
  }

  state = {
    note: null
  }

  handleApproveEventModal = (ajEventIdApprove, isAssessorManagementEnabled) => {
    this.setState(
      {
        ajEventIdApprove,
        isAssessorManagementEnabled
      },
      () => {
        this.props.modal('modal-approve-aj-event')
      }
    )
  }

  handleRejectEventModal = (ajEventIdReject, isAssessorManagementEnabled) => {
    this.setState(
      {
        ajEventIdReject,
        isAssessorManagementEnabled
      },
      () => {
        this.props.modal('modal-reject-aj-event')
      }
    )
  }

  ajLinkFor = award => {
    const level = `${get(award, 'awardLevel.value')}-level`.toLowerCase()

    return `${config.publicPath}/participants/${get(award, 'participant.id')}/${level}/aj`
  }

  handleShowNote = note => {
    this.setState({ note })
    this.props.modal(`modal-show-note-${this.key}`)
  }

  getAssessorInfo = (award, ajEvent, note, isAssessorManagementEnabled) => {
    const rejectedByAssessor = get(ajEvent, 'isAcceptedByAssessor') === false && note

    if (isAssessorManagementEnabled) {
      if (!get(ajEvent, 'assessorEmail')) {
        return (<div className={styles.required}>
          <Link to={this.ajLinkFor(get(ajEvent, 'award'))}>
            <FormattedMessage
                className="control-label"
                id="label.assessor_required"
                defaultMessage="Assessor required"
            />
          </Link>
          {get(ajEvent, 'activityCategory.userDefined') && <div>
            <FormattedMessage
                id="label.other_activity_selected"
                defaultMessage="(OTHER activity selected)"
            />
          </div>}
          {note && <div><br /><Button
              type="button"
              link
              intlKey="button.view_reason"
              onClick={() => this.handleShowNote(note)}
          >
            View reason
          </Button></div>}
        </div>)
      }

      if (get(ajEvent, 'assessor')) {
        const id = get(ajEvent, 'assessor.person.id')

        const orgId = get(ajEvent, 'assessor.organization.id')

        return (<div className={styles.required}>
          {rejectedByAssessor && <Link to={this.ajLinkFor(get(ajEvent, 'award'))}>
            <FormattedMessage
                className="control-label"
                id="label.assessor_required"
                defaultMessage="Assessor required"
            />
          </Link>}
          {rejectedByAssessor && <div><br /><FormattedMessage
              className="control-label"
              id="label.activity_rejected_by"
              defaultMessage="Activity was rejected by"
          /></div>}
          {<Link
              to={{
                pathname: `${config.publicPath}/organizations/${orgId}/assessors/${id}/detail`
              }}
          > {get(ajEvent, 'assessor.person.name')}</Link>}
          {rejectedByAssessor && <div><br /><Button
              type="button"
              link
              intlKey="button.view_reason"
              onClick={() => this.handleShowNote(note)}
          >
            View reason
          </Button></div>}
          {!rejectedByAssessor && <br />}
          {!rejectedByAssessor && get(ajEvent, 'assessor.person.email') && <small>{get(ajEvent, 'assessor.person.email')}</small> ||
          !rejectedByAssessor && get(ajEvent, 'assessor.person.phone') && <small>{get(ajEvent, 'assessor.person.phone')}</small>}
          {!rejectedByAssessor && <br />}
          {!rejectedByAssessor && get(ajEvent, 'assessorRelevantExperience') && <small>{get(ajEvent, 'assessorRelevantExperience')}</small>}
        </div>)
      }
    }
    return (<div>
      {get(ajEvent, 'assessorName') || get(ajEvent, 'assessorEmail') && get(ajEvent, 'assessorPhone') || '-'}
      <br />
      {get(ajEvent, 'assessorEmail') && <small>{get(ajEvent, 'assessorEmail')}</small> ||
      get(ajEvent, 'assessorPhone') && <small>{get(ajEvent, 'assessorPhone')}</small>}
      <br />
      { get(ajEvent, 'assessorRelevantExperience') && <small>{get(ajEvent, 'assessorRelevantExperience')}</small>}
    </div>)
  }


  render() {
    const {
      tasks: { loading, list, offset, limit, pages, sort },
      setParams,
      approveModal,
      hideLimit,
      rejectModal,
      codeLists
    } = this.props


    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.ajEventsApproval}
          setParams={setParams}
          hideLimit={hideLimit}
        >
          <Data>
            {list.map(({ id, award, ajEvent, note }) => {
              const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(ajEvent)

              return (<tr key={id}>
                <td>
                  <Link
                    to={`${config.publicPath}/adventurous-journeys/${get(ajEvent, 'id')}/detail`}
                  >
                    {get(ajEvent, 'id')}
                  </Link>
                </td>
                <td>{get(ajEvent, 'ajEventCategory.translationText')}</td>
                <td>
                  <BadgesLevels
                    levels={[{ awardLevel: get(ajEvent, 'awardLevel') }]}
                    single
                  />
                </td>
                <td>{get(ajEvent, 'activityCategory.translatedName')}</td>
                <td>
                  {get(ajEvent, 'activityCategory.parent.translatedName')}
                </td>
                <td>
                  {get(ajEvent, 'startDate') &&
                    <FormattedDate value={ajEvent.startDate} />}
                </td>
                <td>
                  {get(ajEvent, 'endDate') &&
                    <FormattedDate value={ajEvent.endDate} />}
                </td>
                <td>
                  {get(ajEvent, 'createdByPerson.firstName')}{' '}
                  {get(ajEvent, 'createdByPerson.lastName')}
                </td>
                <td>
                  {this.getAssessorInfo(award, ajEvent, note, isAssessorManagementEnabled)}
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      type="button"
                      tiny
                      onClick={() =>
                        this.handleApproveEventModal(get(ajEvent, 'id'), isAssessorManagementEnabled)}
                      intlKey={isAssessorManagementEnabled ? 'button.authorize' : 'button.approve'}
                    >
                      {isAssessorManagementEnabled ? 'Authorize' : 'Approve'}
                    </Button>
                    <Button
                      type="button"
                      tiny
                      onClick={() =>
                        this.handleRejectEventModal(get(ajEvent, 'id'), isAssessorManagementEnabled)}
                      intlKey="button.revise"
                      secondary
                    >
                      Revise
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            )})}
          </Data>
        </Table>
        <Modal id="modal-approve-aj-event" customActions>
          <TaskApprove
            id={this.state.ajEventIdApprove}
            approve={approveModal}
            modal={this.props.modal}
            activityState={PROGRESS_STATES.activityApproval.id}
            isAssessorManagementEnabled={this.state.isAssessorManagementEnabled}
            title="Approve event"
            intlKey="tasks.approve_event"
          />
        </Modal>
        <Modal id="modal-reject-aj-event" customActions enableOverflow>
          <TaskReturn
            id={this.state.ajEventIdReject}
            returnTask={rejectModal}
            modal={this.props.modal}
            isAssessorManagementEnabled={this.state.isAssessorManagementEnabled}
            showReasons={true}
            codeLists={codeLists}
          />
        </Modal>
        <Modal
            id={`modal-show-note-${this.key}`}
            closeAction="Close"
            intlKeyClose="modal.close"
        >
          <div>
            <h2 className="text--center">
              <FormattedMessage id="title.rejection_reason" defaultMessage="Reason of rejection" />
            </h2>
            <p>{this.state.note}</p>
          </div>
        </Modal>
      </div>
    )
  }
}
